import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPreCommitComponent } from './simple-icons-pre-commit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPreCommitComponent ],
    exports:      [ SimpleIconsPreCommitComponent ],
    bootstrap:    []
})
export class SimpleIconsPreCommitModule {}
